import Actions from 'actions'
import { ofType } from 'redux-observable'
import { debounceTime, filter, ignoreElements, map, pluck, tap, withLatestFrom } from 'rxjs/operators'
import { api } from 'store/api'
import { ModuleTags } from 'store/modules/consts'
import { fetchTotalUnreadNotifications } from 'store/modules/NotificationCenter'

export const refreshNotificationsOnMessageReceivedEpic = action$ =>
  action$.pipe(
    ofType(Actions.NOTIFICATION_RECEIVED),
    filter(({ payload }) => payload.entityType === 'newMessage'),
    debounceTime(6000), // Accumulate live updates for 6 seconds before refreshing the notifications data.
    map(() => api.util.invalidateTags([ModuleTags.UnreadNotifications, ModuleTags.GrinNotificationsList]))
  )

export const setPageTitleEpic = (action$, state$) =>
  action$.pipe(
    filter(fetchTotalUnreadNotifications.matchFulfilled),
    pluck('payload'),
    withLatestFrom(state$),
    map(([unreadStats, state]) => ({
      practiceName: state.practiceReducer.details?.practiceName,
      totalUnread: unreadStats.total
    })),
    tap(({ practiceName, totalUnread }) => {
      let title = practiceName ? `Grin - ${practiceName}` : 'Grin'
      if (totalUnread) {
        title = `${title} (${totalUnread})`
      }
      document.title = title
    }),
    ignoreElements()
  )
